<script setup>
import {
  nextTick,
  onMounted,
  onUnmounted,
  ref,
  useAttrs,
  watch,
  computed,
} from 'vue';
import CsToastItem from './CsToastItem.vue';
import { useToast } from './useToast';

const { subscribe } = useToast();

const GAP = 14;
const attrs = useAttrs();
const toasts = ref([]);
const heights = ref([]);
const expanded = ref(false);
const interacting = ref(false);

const toastStyle = computed(() => {
  const height = (heights.value[0] && heights.value[0].height) || 0;
  return {
    '--front-toast-height': `${height}px`,
    '--offset': '32px',
    '--gap': `${GAP}px`,
    ...attrs.style,
  };
});

function removeToast(toast) {
  toasts.value = toasts.value.filter(({ id }) => id !== toast.id);
}

function onMouseLeave() {
  if (!interacting.value) {
    expanded.value = false;
  }
}

onMounted(() => {
  const unsubscribe = subscribe(toast => {
    if (toast.dismiss) {
      toasts.value = toasts.value.map(t =>
        t.id === toast.id ? { ...t, delete: true } : t
      );
      return;
    }

    nextTick(() => {
      const indexOfExistingToast = toasts.value.findIndex(
        t => t.id === toast.id
      );

      // Update the toast if it already exists
      if (indexOfExistingToast !== -1)
        toasts.value.splice(indexOfExistingToast, 1, toast);
      else toasts.value = [toast, ...toasts.value];
    });
  });

  onUnmounted(() => {
    unsubscribe();
  });
});

watch(
  () => toasts.value.length,
  length => {
    if (length <= 1) expanded.value = false;
  }
);
</script>

<template>
  <section data-component="CsToastContainer" :tabIndex="-1">
    <div
      class="fixed z-[999999] flex flex-col gap-2 items-center justify-center w-full left-1/2 -translate-x-1/2 top-[max(var(--offset),env(safe-area-inset-top))]"
      data-component="CsToast"
      :tabIndex="-1"
      :style="toastStyle"
      @mouseenter="expanded = true"
      @mousemove="expanded = true"
      @mouseleave="onMouseLeave"
      @pointerdown="interacting = false"
      @pointerup="interacting = false"
    >
      <CsToastItem
        v-for="(toast, index) in toasts"
        :key="toast.id"
        :heights="heights"
        :index="index"
        :toast="toast"
        :visible-toasts="10"
        :interacting="interacting"
        :toasts="toasts"
        :expanded="expanded"
        @remove="removeToast"
        @update-height="v => (heights = v)"
      />
    </div>
  </section>
</template>
